import React from 'react';
import RoleForm from './role_form';
import {notification} from 'antd';
import history from '../../modules/History';
import {getRoleItem, updateRoleItem} from '../../modules/Api';

class EditRole extends React.Component {
    constructor() {
        super();
        this.state = {
            data: {},
            submitted: false,
        }

    }

    componentDidMount() {
        const id = this.props.match.params.id;
        getRoleItem(id, (res)=>{
            if(res.status==200){
                this.setState({data: res.data});
            }
        });
    }

    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        updateRoleItem(this.state.data.id, values, (res) => {
            this.setState({submitted:false});

            if(res.status==200){
                notification.open({
                    message: `نقش با موفقیت ویرایش شد!`,
                });
                history.item.push(`/acl/roles`);
            }
            else if(res.message != undefined){
                notification.open({
                    message: res.message,
                });
            }
        });
    }
    render() {
        if(this.state.data.id == undefined){
            return 'لطفا منتظر بمانید';
        }
        return (<RoleForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/>);
    }
}

export default EditRole;


// WEBPACK FOOTER //
// ./src/containers/ACL/edit_role.js